/**
 * This directive works around all the nuances of textarea placeholders:
 * - Firefox doesn't acknowledge \n and allow multiline placeholders
 * - IE sometimes turns the placeholder into a value
 */

module.exports = {
	bind(el, { value }) {
		el.dataset.placeholder = value;

		const textarea = el.querySelector('textarea');
		const placeholderEl = document.createElement('div');
		placeholderEl.classList.add('safe-placeholder');
		el.appendChild(placeholderEl);

		const blurHandler = () => {
			if (!el.dataset.placeholder || textarea.value.trim()) {
				return;
			}

			placeholderEl.hidden = false;
		};

		const focusHandler = () => {
			if (!el.dataset.placeholder) {
				return;
			}

			placeholderEl.hidden = true;
			textarea.focus();
		};

		placeholderEl.onclick = focusHandler;

		textarea.placeholderFocusHandler = focusHandler;
		textarea.placeholderBlurHandler = blurHandler;

		textarea.addEventListener('focus', textarea.placeholderFocusHandler);
		textarea.addEventListener('blur', textarea.placeholderBlurHandler);
	},
	unbind(el) {
		const placeholderEl = el.querySelector('.safe-placeholder');
		placeholderEl.remove();

		const textarea = el.querySelector('textarea');

		textarea.removeEventListener('focus', textarea.placeholderFocusHandler);
		textarea.removeEventListener('blur', textarea.placeholderBlurHandler);
		textarea.placeholderFocusHandler = undefined;
		textarea.placeholderBlurHandler = undefined;
	},
	update(el, { value }) {
		el.dataset.placeholder = value;

		el.querySelector('.safe-placeholder').textContent = value;
	}
};
